// extracted by mini-css-extract-plugin
module.exports = {"button":"Truncate_button___L5NQ","text":"Truncate_text__LNb7W"};